//Install
import React, { Component } from "react";
//Install
import { Row, Col } from "react-bootstrap";
//Install
import D049JS from "../../../Media/Image/015.jpg";

//Element
class H03U9W extends Component {
    //Element
    render() {
        //Element
        const Content = React.createElement("a", { className: "S6pt64 C96Q4r pEO064 a527eB v725gm", href: "/projeler" },
            //Element
            React.createElement(Row, {},
                //Element
                React.createElement(Col, { md: 6 },
                    //Element
                    React.createElement("picture", { className: "S6pt64 C96Q4r pEO064 a527eB n02a9p" },
                        //Element
                        React.createElement("img", { alt: "Fabrika", title: "Fabrika", src: D049JS, width: "306", height: "auto" })
                    )
                ),
                //Element
                React.createElement(Col, { md: 6 },
                    //Element
                    React.createElement("div", { className: "S0u16d C96Q4r g1aS48 d721Vx pEO064 a527eB z3630j" },
                        //Element
                        React.createElement("h4", { className: "S6pt64 C96Q4r pEO064 a527eB u50e58" },
                            //Element
                            "Fabrika"
                        ),
                        //Element
                        React.createElement("span", { className: "S6pt64 C96Q4r pEO064 a527eB q8913p" },
                            //Element
                            "5"
                        )
                    )
                )
            )
        )
        //Element
        return (
            Content
        );
    }
}
//Element
export default H03U9W;